import { initImpressionTracking } from "@websim/core/src/activity/impression-tracking";
import isMobile from "is-mobile";
import { posthog } from "posthog-js";
import { $PROJECT_ID_LEGACY } from "../../../pages/app/utils/posthog-attributes";
import { deepFreeze } from "../utils/deep-freeze";
import { initActivityTracking } from "./activity-tracking";
import { initContextMenu } from "./context-menu";
import { initEditorFunctionality } from "./editor-functionality";
import { setupErrorCatching } from "./error-catching";
import { hijackEvents } from "./hijack";
import { injectLogo } from "./inject-logo";
import { initLoadProgress } from "./loading";
import { patchFetch } from "./patch-fetch";
import { initPlugins } from "./plugins";
import { relayUrlChangesToHost } from "./relay-url-changes-to-host";
import { initRuntime } from "./runtime";
import type { WebsimData } from "./types";
import { WebsimSocket } from "./websimSocket";
declare global {
  const __WEBSIM_DATA__: WebsimData;
  interface Window {
    baseUrl: string;
  }
}

if (!window.websim) {
  window.baseUrl = __WEBSIM_DATA__.baseUrl;
  initRuntime();
  if (!__WEBSIM_DATA__.isTopLevelFrame) initLoadProgress();
  hijackEvents();
  setupErrorCatching();
  initPlugins();
  patchFetch();
  relayUrlChangesToHost();
  if (!__WEBSIM_DATA__.isTopLevelFrame) initEditorFunctionality();
  deepFreeze(window.websim);
  (window as any).WebsimSocket = WebsimSocket;
  if (!isMobile()) {
    initContextMenu();
  }
}

document.querySelectorAll("script.websim-injected").forEach((script) => {
  script.remove();
});

void (async () => {
  let bootstrap:
    | Awaited<ReturnType<typeof window.websim.getBootstrap>>
    | undefined;

  try {
    bootstrap = await window.websim.getBootstrap();
  } catch (e) {
    console.error(e);
  } finally {
    posthog.init("phc_VHMOlrdxAbgSZHeF0SdSf07LZLRLAg5pZuTHkJGn050", {
      api_host: "https://e.wbsm.ai",
      ui_host: "https://app.posthog.com",
      session_recording: {
        recordCrossOriginIframes: true,
      },
      capture_pageview: false,
      ...(bootstrap
        ? {
            bootstrap: {
              distinctID: bootstrap.distinct_id,
              sessionID: bootstrap.session_id,
            },
          }
        : {}),
    });
    if (__WEBSIM_DATA__.home) {
      initImpressionTracking({
        distinctId: bootstrap?.distinct_id,
        sessionId: bootstrap?.session_id,
      });
    }
    initActivityTracking({
      distinctId: bootstrap?.distinct_id,
      sessionId: bootstrap?.session_id,
    });

    if (__WEBSIM_DATA__.isTopLevelFrame) {
      posthog.capture("$pageview", {
        project_id: __WEBSIM_DATA__.project_id,
        [$PROJECT_ID_LEGACY]: __WEBSIM_DATA__.project_id,
      });
    }

    if (__WEBSIM_DATA__.isTopLevelFrame) {
      const author = await window.websim.getCreatedBy();
      injectLogo({
        author: author ?? undefined,
      });
    }
  }
})();
